import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import style from "./home.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import VideoPlayer from "../../modals/videoPlayer/VideoPlayer";
import { useDispatch } from "react-redux";
import { searchCenters } from "../../apis/CenterApis";
import axios from "axios";
import { baseUrl } from "../../utils/api";
// import { fileBaseUrl } from "../../utils/api";

const CenterList = ({ centerList, searchCenter, showfilter }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [showNext, setShowNext] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(21);
  const [liveSet, setLiveSet] = useState(new Set());
  const [liveMeta, setLiveMeta] = useState({});
  // const [isdata, setIsData] = useState(false);

  const sanitizeFolderName = (name) => {
    if (!name || typeof name !== 'string') return '';
    let clean = name.replace(/[^a-zA-Z0-9-_\s]/g, '_');
    clean = clean.replace(/[\s-_]+/g, ' ').trim();
    clean = clean.replace(/\s+/g, '_');
    return clean;
  };

  // useEffect(() => {
  //   const host = window.location.hostname;
  //   const primary = (host === 'localhost' || host === '127.0.0.1') ? 'http://localhost:5000' : baseUrl.replace('/v1','');
  //   const fallback = (primary.includes('localhost')) ? baseUrl.replace('/v1','') : 'http://localhost:5000';
  //   const candidates = [primary, fallback].filter((v, i, arr) => arr.indexOf(v) === i);

  //   let timer = null;
  //   const poll = async () => {
  //     for (const root of candidates) {
  //       try {
  //         const res = await axios.get(`${root}/v1/stream/live`, {
  //           params: { ts: Date.now() },
  //           headers: { 'Cache-Control': 'no-cache' }
  //         });
  //         if (res && res.status === 200) {
  //           const live = res.data?.folders || [];
  //           setLiveSet(new Set(live));
  //           setLiveMeta(res.data?.meta || {});
  //         }
  //         break;
  //       } catch (_) {
  //       }
  //     }
  //   };
  //   poll();
  //   timer = setInterval(poll, 3000);
  //   return () => { if (timer) clearInterval(timer); };
  // }, []);

  function truncateString(str, maxLength) {
    if (str?.length <= maxLength) {
      return str;
    } else {
      return str?.slice(0, maxLength) + "...";
    }
  }

  const filesData = (value) => {
    const addfileType = value?.map((file) => {
      const fileExtension = file?.media?.split(".").pop().toLowerCase();
      const imageExtensions = ["jpg", "jpeg", "png", "gif"];
      const videoExtensions = ["mp4", "avi", "mov", "mkv"];
      const youtubePattern =
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;

      if (imageExtensions.includes(fileExtension)) {
        file.type = "image";
      } else if (youtubePattern.test(file.media)) {
        file.type = "youtube";
      }
      else if (videoExtensions.includes(fileExtension)) {
        file.type = "video";
      }
      else {
        file.type = "unsupported";
      }
      // setIsData(true);
      return file;
    });
    return addfileType;
  };

  const fetchSearchCenter = () => {
    dispatch(
      searchCenters({
        centerName: searchCenter,
        // country: selectedCountry,
        // state: selectedState,
        page: page,
        limit: limit,
      })
    ).then((res) => {
      if (res) {
        setFiles(filesData(res?.centersList));
        setPage(res?.currentPage);
        if (res?.currentPage < res?.totalPages) {
          setShowNext(true);
        } else {
          setShowNext(false);
        }
      }
    });
  };

  useEffect(() => {
    setFiles(filesData(centerList));
  }, [centerList]);

  useEffect(() => {
    if (!searchCenter) {
      setFiles(filesData(centerList));
    }
  }, [searchCenter]);

  useEffect(() => {
    if (showfilter && searchCenter) {
      fetchSearchCenter();
    }
  }, [showfilter]);

  const handlejanet = () => {
    const id = "66f2a41ba8462a390b54d2b4"; // Replace with the actual ID
    navigate(`/donation/${id}`);
  };
  const handleClick = (data) => {
    // navigate("/donation",  { state: data });
    navigate(`/donation/${data.id ? data.id : data._id}`);

    localStorage.setItem("centerId", data.id ? data.id : data._id);
  };
  const handlePlay = (url) => {
    setVideoUrl(url);

    setShowVideoPlayer(true);
  };

  const handleShowMore = () => {
    dispatch(
      searchCenters({
        centerName: searchCenter,
        // country: selectedCountry,
        // state: selectedState,
        page: page + 1,
        limit: limit,
      })
    ).then((res) => {
      if (res) {
        setFiles(filesData(res?.centersList));
        setPage(res?.currentPage);
        if (res?.currentPage < res?.totalPages) {
          setShowNext(true);
        } else {
          setShowNext(false);
        }
      }
    });
  };
  function truncateText(text, maxLength) {
    if (text.length <= maxLength) {
      return `, ${text}`;
    }
    return `, ${text.substr(0, maxLength) + "..."}`;
  }
  function getYouTubeVideoId(url) {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|.+\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }

  return (
    <div>
      <div className={style.maincentercontainer} style={{}}>
        <div className={style.dashboard_row}>
          {/* <div className="container">
            <h1 className={style.centerlistheading}>Ready to Keep Hope Alive? Let’s take the next step.</h1>
          </div> */}

          {/* <div className="container">
            <Row className="m-0 p-0">
              {files
                ?.filter((data) => data?.description)
               
                    .sort((a, b) => {
                        const prioritized = ["Houston Coalition for Life", "Journey Home", "Life in Mercy"];
                        const aPriority = prioritized.findIndex(name =>
                          a.centerName?.toLowerCase().includes(name.toLowerCase()));
                        const bPriority = prioritized.findIndex(name =>
                          b.centerName?.toLowerCase().includes(name.toLowerCase()));

                        if (aPriority !== -1 && bPriority !== -1) return aPriority - bPriority;
                        if (aPriority !== -1) return -1;
                        if (bPriority !== -1) return 1;
                        return 0;
                      }).slice(0,3)
                .map((data, index) => (
                  <Col className="p-3 " key={index} lg={4} md={6} sm={6}>
                    <div className={`bg-main   ${style.centerCard}`}>
                      <div
                        className="position-relative image-container"
                        style={{ height: "150px" }}
                      >
                        {data?.type === "unsupported" && (
                          <img
                            className={`w-100 h-100`}
                            src={`/defaultCenter.png`}
                            alt="center"
                          />
                        )}
                        {data?.type === "image" && (
                          <img
                            className={`w-100 h-100`}
                            src={`${data.media}`}
                            alt="center"
                          />
                        )}

                        {data?.type === "youtube" && (
                          <iframe
                            src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                              data.media
                            )}`}
                            frameborder="0"
                            allow="encrypted-media"
                            allowfullscreen
                            title="video"
                            width="100%"
                            height="100%"
                            className="rounded-1"
                          />
                        )}
                     
                        
                        {(() => {
                          const isLive = liveSet.has(sanitizeFolderName(data?.centerName));
                          if (!isLive) return null;
                          return (
                            <span className="pulse-dot" style={{
                              position: 'absolute',
                              top: 8,
                              right: 8,
                              width: 12,
                              height: 12,
                              borderRadius: '50%',
                              backgroundColor: '#22c55e',
                              boxShadow: '0 0 0 2px rgba(255,255,255,0.9)',
                              zIndex: 999,
                              pointerEvents: 'none'
                            }} title="Live" />
                          );
                        })()}

                        <div
                          class="overlay rounded-1"
                          onClick={() =>
                            (data?.type === "youtube" ||data?.type === "video") && handlePlay(data?.media)
                          }
                        ></div>
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleClick(data)}
                      >
                        <div
                          className="my-2 text-white"
                          style={{
                            fontSize: "17px",
                            textTransform: "capitalize",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          {truncateString(data.centerName, 30)}
                        </div>
                        <div
                          style={{
                            color: "white",
                            minHeight: "120px",
                            maxHeight: "120px",
                            WebkitLineClamp: 4,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "17px",
                            lineHeight: "30px",
                            fontWeight: "400",
                            // whiteSpace:"nowrap"
                          }}
                        >
                          {(() => {
                            const key = sanitizeFolderName(data.centerName);
                            const desc = liveSet.has(key) && liveMeta?.[key]?.description ? liveMeta[key].description : data.description;
                            return truncateString(desc, 120);
                          })()}
                        </div>
                      </div>
                      <div
                        className=" d-flex justify-content-between align-items-center text-white "
                        style={{ marginTop: "28px" }}
                      >
                        <Col md={6}>
                          <div className={style.location}>
                            {" "}
                            {data.country === "United States"
                              ? "US"
                              : data.country}
                            {data.state ? truncateText(data.state, 12) : ""}{" "}
                          </div>
                        </Col>
                        <Col md={6} className={style.centerdonatebutton}>
                          <Button
                            variant="danger redbtn"
                            size="sm"
                            className=" px-3 rounded-1"
                            onClick={() => handleClick(data)}
                          >
                            Donate Now{" "}
                          </Button>
                        </Col>
                      </div>
                    </div>
                  </Col>
                ))}
            </Row>
          </div> */}
          {showNext && (
            <div className="text-center">
              <Button variant="light"
                onClick={handleShowMore}
              >
                See  Featured Fundraisers
              </Button>
            </div>
          )}
          {location?.pathname !== "/search-campaign" && files?.length !== 0 && (
            <div className="text-center">
              <Button
                variant="danger"
                size="lg"
                className=" px-5 rounded-1 redbtn"
                onClick={() => navigate("/search-campaign")}
              >
                See Featured Fundraisers{" "}
              </Button>
            </div>
          )}
        </div>
      </div>
      {/* <VideoPlayer
        showVideoPlayer={showVideoPlayer}
        setShowVideoPlayer={setShowVideoPlayer}
        videoUrl={videoUrl}
        // isdata={isdata}
      /> */}
    </div>
  );
};

export default CenterList;
